import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthGuardService } from '@app/auth/services/auth-guard.service';
import { UserLevel } from '@app/core/models/user-level';
import { SystemInfoComponent } from '@business/system/components/system-info/system-info.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        canActivate: [AuthGuardService],
        component: SystemInfoComponent,
        data: {
          requiredUserLevel: UserLevel.SystemAdmin,
        },
        path: 'system-info',
      },
      {
        loadChildren: () =>
          import(/* webpackChunkName: "downloads" */ '../download/download-system-admin-routing.module').then(
            (m) => m.DownloadSystemAdminRoutingModule
          ),
        path: 'downloads',
      },
      {
        loadChildren: () =>
          import(/* webpackChunkName: "files" */ '../download/files-system-admin-routing.module').then(
            (m) => m.FilesSystemAdminRoutingModule
          ),
        path: 'files',
      },
      {
        loadChildren: () =>
          import(
            /* webpackChunkName: "downloads" */ '../soft-clients/soft-clients-system-admin-routing.module'
          ).then((m) => m.SoftClientsSystemAdminRoutingModule),
        path: 'soft-clients',
      },
      {
        loadChildren: () =>
          import(/* webpackChunkName: "downloads" */ '../document/document-system-admin-routing.module').then(
            (m) => m.DocumentSystemAdminRoutingModule
          ),
        path: 'documents',
      },
      {
        loadChildren: () =>
          import(
            /* webpackChunkName: "notifications" */ '../notification/notification-system-admin-routing.module'
          ).then((m) => m.NotificationServiceProviderRoutingModule),
        path: 'notifications',
      },
    ]),
  ],
})
export class SystemRoutingModule {}
